/**
 * №11.3 — client-side reading of field/type provenance. The server stamps each
 * field's `origin` ("<module_slug>@<version>" for module-owned, "workspace" for
 * customer-added); the console reads it to show the lock glyph + "Part of the X
 * module" and to disable delete on module-owned schema. The server is the
 * enforcer — this is the honest UI signal, not the gate.
 */
import type { FieldDefinition } from "../../lib/types";

/** True when a field's origin marks it module-owned (locked). */
export function fieldIsModuleOwned(origin: string | undefined): boolean {
  return !!origin && origin !== "workspace" && origin.includes("@");
}

/** The owning module slug for a type, inferred from its module-owned fields
 *  (a module type always ships module-origin fields). Null when the type is a
 *  pure workspace type. */
export function typeModuleOwner(fields: FieldDefinition[] | undefined): string | null {
  const f = (fields ?? []).find((x) => fieldIsModuleOwned(x.origin));
  if (!f?.origin) return null;
  return f.origin.split("@")[0] || null;
}

/** Human label for a module slug (branding proper is deferred to №14, D-MOD4). */
export function moduleLabel(slug: string): string {
  return slug.charAt(0).toUpperCase() + slug.slice(1).replace(/-/g, " ");
}
